import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  ASTRACHAT_VERSION: astrachatVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  GOOGLE_TRANSLATE_ENABLED: googleTranslateEnabled,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DISABLE_META_INBOX_CREATION: disableMetaInboxCreation,
  DISABLE_META_MESSAGE_SENDING: disableMetaMessageSending,
  DEPLOYMENT_ENV: deploymentEnv,
  CONTACTS_ALLOW_DELETE: contactsAllowDelete,
  SIMPLE_MODE_CONFIG: simpleModeConfigRaw,
  CONVERSATION_NAV_CONFIG: conversationNavConfigRaw,
  ACTIVE_PLATFORM_BANNERS: activePlatformBanners,
  ACTIVE_PLATFORM_NOTIFICATIONS: activePlatformNotifications,
  PLATFORM_NOTIFICATIONS_UI: platformNotificationsUi,
  WHITE_LABEL: whiteLabel,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  astrachatVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  disableMetaInboxCreation: parseBoolean(disableMetaInboxCreation),
  disableMetaMessageSending: parseBoolean(disableMetaMessageSending),
  // Ausente no globalConfig = liberado (default histórico).
  contactsAllowDelete:
    contactsAllowDelete === undefined || contactsAllowDelete === null
      ? true
      : parseBoolean(contactsAllowDelete),
  simpleModeConfig: simpleModeConfigRaw || null,
  conversationNavConfig: conversationNavConfigRaw || null,
  displayManifest,
  gitSha,
  googleTranslateEnabled: googleTranslateEnabled === true,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  isWhiteLabel: whiteLabel === true,
  activePlatformBanners: activePlatformBanners || [],
  activePlatformNotifications: activePlatformNotifications || [],
  platformNotificationsUi: platformNotificationsUi || {
    placement: 'popup_right_center',
  },
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isMetaInboxCreationDisabled: $state =>
    $state.deploymentEnv === 'cloud' && $state.disableMetaInboxCreation,
  isMetaMessageSendingDisabled: $state =>
    $state.deploymentEnv === 'cloud' && $state.disableMetaMessageSending,
  isContactDeleteAllowed: $state => $state.contactsAllowDelete !== false,
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
